import { FeatureFlag, useFeatureGate } from "features/Statsig";
import useClerkMetadata from "features/User/hooks/useClerkMetadata";

export const useDeepSearchAnnouncementBanner = () => {
  const deepSearchAnnouncementBannerFeatureFlag = useFeatureGate(
    FeatureFlag.DEEP_SEARCH_ANNOUNCEMENT_BANNER
  ).value;
  const { userMetadata, updateUserMetadata, isUserMetadataLoaded } =
    useClerkMetadata();

  const dismissDeepSearchBanner = () => {
    updateUserMetadata({
      is_deep_search_banner_hidden: true,
    });
  };

  return {
    isDeepSearchBannerHidden:
      !deepSearchAnnouncementBannerFeatureFlag ||
      !isUserMetadataLoaded ||
      userMetadata?.is_deep_search_banner_hidden === true,
    dismissDeepSearchBanner,
  };
};
